var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSliderBricks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.953,
    height: 23.333,
    viewBox: "0 0 33.953 23.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4540",
    "data-name": "Rectangle 4540",
    width: 33.953,
    height: 23.333,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4587",
    "data-name": "Group 4587",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4537",
    "data-name": "Rectangle 4537",
    width: 8.441,
    height: 3.532,
    transform: "translate(13.97 19.127)",
    fill: "#e07a5f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4538",
    "data-name": "Rectangle 4538",
    width: 8.441,
    height: 3.532,
    transform: "translate(24.838 19.127)",
    fill: "#e07a5f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4539",
    "data-name": "Rectangle 4539",
    width: 8.441,
    height: 3.532,
    transform: "translate(24.838 13.631)",
    fill: "#e07a5f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4586",
    "data-name": "Group 4586",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4585",
    "data-name": "Group 4585",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7736",
    "data-name": "Path 7736",
    d: "M11.542,38.934H.674A.674.674,0,0,1,0,38.26v-5.5a.674.674,0,0,1,.674-.674H11.542a.674.674,0,0,1,.674.674v5.5a.674.674,0,0,1-.674.674M1.348,37.586h9.521V33.438H1.348Z",
    transform: "translate(0 -21.097)",
    fill: "#0f475d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7737",
    "data-name": "Path 7737",
    d: "M43.268,38.934H32.4a.674.674,0,0,1-.674-.674v-5.5a.674.674,0,0,1,.674-.674H43.268a.674.674,0,0,1,.674.674v5.5a.674.674,0,0,1-.674.674M33.074,37.586h9.521V33.438H33.074Z",
    transform: "translate(-20.858 -21.097)",
    fill: "#0f475d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7738",
    "data-name": "Path 7738",
    d: "M75,38.934H64.127a.674.674,0,0,1-.674-.674v-5.5a.674.674,0,0,1,.674-.674H75a.674.674,0,0,1,.674.674v5.5a.674.674,0,0,1-.674.674M64.8,37.586h9.521V33.438H64.8Z",
    transform: "translate(-41.716 -21.097)",
    fill: "#0f475d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7739",
    "data-name": "Path 7739",
    d: "M11.542,54.978H.674A.674.674,0,0,1,0,54.3v-5.5a.674.674,0,0,1,.674-.674H11.542a.674.674,0,0,1,.674.674v5.5a.674.674,0,0,1-.674.674M1.348,53.63h9.521V49.482H1.348Z",
    transform: "translate(0 -31.645)",
    fill: "#0f475d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7740",
    "data-name": "Path 7740",
    d: "M43.268,54.978H32.4a.674.674,0,0,1-.674-.674v-5.5a.674.674,0,0,1,.674-.674H43.268a.674.674,0,0,1,.674.674v5.5a.674.674,0,0,1-.674.674M33.074,53.63h9.521V49.482H33.074Z",
    transform: "translate(-20.858 -31.645)",
    fill: "#0f475d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7741",
    "data-name": "Path 7741",
    d: "M75,54.978H64.127a.674.674,0,0,1-.674-.674v-5.5a.674.674,0,0,1,.674-.674H75a.674.674,0,0,1,.674.674v5.5a.674.674,0,0,1-.674.674M64.8,53.63h9.521V49.482H64.8Z",
    transform: "translate(-41.716 -31.645)",
    fill: "#0f475d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7742",
    "data-name": "Path 7742",
    d: "M26.312,22.888H15.444a.674.674,0,0,1-.674-.674v-5.5a.674.674,0,0,1,.674-.674H26.312a.674.674,0,0,1,.674.674v5.5a.674.674,0,0,1-.674.674M16.118,21.541h9.52V17.392h-9.52Z",
    transform: "translate(-9.71 -10.548)",
    fill: "#0f475d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7743",
    "data-name": "Path 7743",
    d: "M58.037,22.888H47.169a.674.674,0,0,1-.674-.674v-5.5a.674.674,0,0,1,.674-.674H58.037a.674.674,0,0,1,.674.674v5.5a.674.674,0,0,1-.674.674M47.843,21.541h9.521V17.392H47.843Z",
    transform: "translate(-30.567 -10.548)",
    fill: "#0f475d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7744",
    "data-name": "Path 7744",
    d: "M42.176,6.844H31.308a.674.674,0,0,1-.674-.674V.674A.674.674,0,0,1,31.308,0H42.176a.674.674,0,0,1,.674.674v5.5a.674.674,0,0,1-.674.674M31.982,5.5H41.5V1.348h-9.52Z",
    transform: "translate(-20.14 0)",
    fill: "#0f475d"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderBricks);
export default __webpack_public_path__ + "static/media/sliderBricks.03992bff279b7864811fb54f187cf081.svg";
export { ForwardRef as ReactComponent };